// Transforms serie name to lower case and removes white space
export const transformSerieName = (name: string) => {
  if (!name) {
    return '';
  }

  return name.toLowerCase().replace(/\s/g, '');
};
